import { AppHelper } from "../../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../../core/components/commonApp";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { General } from "../../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Helper } from "../../core/util/helper";
import { Language } from "../../reportMetaData/reportMetaDataHelper";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Config } from "../../core/config/config";
import { DialogHelper } from "../../core/util/dialogHelper";
import { SheetEventType } from "../../../siteManagement/sheet";
import { EmailHelper } from "../emailHelper";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";

export class EmailTemplateApp extends React.Component<EmailTemplateProps, any> {
    common = new AppHelper();
    setTabTitle = true;
    translations: StringKeyDictionary<string> = null;
    deleteEnabled = true;
    disableEntityType: boolean = false;
    private languages: Language[];

    constructor(props: EmailTemplateProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.props.context.translations = this.translations;
        this.initApp();
    }

    private initApp = async () => {
        this.disableEntityType = this.props.disableEntityType;
        this.languages = await EmailHelper.loadLanguages();
    }

    private validate = (): Promise<boolean> => {
        return new Promise<boolean>(async (resolve) => {
            let validationResults = await Promise.all([
                (this.common.validate() as boolean),
                this.validateName(),
                this.validateData()
            ]);
            let result = validationResults.filter(f => !f).length == 0;
            if (result) {
                resolve(await checkConsistency(this.props.entity, this.translations));
            } else {
                resolve(false);
            }
        });
    }

    private validateName = () => {
        return new Promise<boolean>((resolve) => {
            let name = this.props.entity.Name;
            const result = Object.keys(name).map((key) => { return !Helper.isNullOrEmpty(name[key]) }).filter(f => f).length > 0;
            if (!result) {
                NotificationHelper.showWarningMessage(this.translations["WebSMS.ReportMetadata.NameIsMissing"]);
            }
            resolve(result);
        });
    }

    private validateData = () => {
        return new Promise<boolean>(async (resolve) => {
            if (!Helper.isObjectEmpty(this.props.entity.Data)) {
                let result = await HTTPService.post<JsonResultClass<string[]>>("EmailSender/ValidateTemplate", this.props.entity);
                if (result.Code == 0) {
                    if (result.Data.length == 0) {
                        resolve(true);
                    } else {
                        const targetElement = $("<div>");
                        const dialogProps: DialogProps = {
                            title: Helper.getTranslation("WebCRM.Email.Problems"),
                            width: 450,
                            actions: [
                                {
                                    label: Config.translations.ok,
                                    action: () => {
                                        resolve(false);
                                    },
                                    primary: true
                                }
                            ],
                            afterClose: () => {
                                ReactDOM.unmountComponentAtNode(targetElement[0]);
                                targetElement[0].remove();
                            }
                        };
                        $("body").append(targetElement);
                        ReactDOM.render(
                            <Dialog {...dialogProps} open={true}>
                                <div>
                                    <label>{this.translations["WebCRM.Email.CheckDatasources"]}</label>
                                    <ul style={{ padding: "5px 20px" }}>
                                        {result.Data.map((code) => {
                                            let lang = this.languages.find(f => f.Code.toLowerCase() == code.toLowerCase());
                                            return <React.Fragment key={kendo.guid()}><li style={{ listStyle: "disc" }}>{`${lang.Displaynameen}(${lang.Displaynamenative})`}</li></React.Fragment>
                                        })}

                                    </ul>
                                </div>
                            </Dialog >, targetElement[0]
                        );
                    }
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                    resolve(false);
                }
            } else {
                NotificationHelper.showWarningMessage(this.translations["WebCRM.Email.AtLeastOnTemplate"]);
                let el = $("div.tabstrip__content > div:nth-child(3)");
                el.click();
            }
        });
    }

    save = async (closeAfterSave) => {
        const isValid = await this.validate();
        if (isValid) {
            const result = await HTTPService.post<JsonResultClass>("EmailSender/SaveTemplate", this.props.entity);
            if (result.Code === 0) {
                this.props.entity.Id = result.Data.Id;
                if (this.props.entity.IsNew) {
                    General.Functions.HistoryState.replaceState("EmailSender/EditTemplate?id=" + encodeURIComponent(this.props.entity.Id));
                }
                this.props.entity.IsNew = false;
                Helper.updateEntity(this.props.entity, result.Data);
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);
        }
    }

    deleteTemplate = async () => {
        let isOK = await DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"]);
        if (isOK) {
            let result = await HTTPService.get<JsonResultClass>("EmailSender/DeleteTemplate?templateId=" + this.props.entity.Id);
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                if (this.common.isWindow) {
                    this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                    this.common.sheetWrapper.hide();
                } else {
                    this.props.entity.RecordRight.CanWrite = false;
                    this.setState({});
                    setTimeout(() => {
                        window.location.href = Config.baseUrl + "DynamicSearch/emailTemplate";
                    }, 1000);
                }
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface EmailTemplateEntity extends Entity {
    Id: string;
    Name: {};
    Data: {};
    EmailDefaults: {
        DocumentsSql: string,
        EmailRecipientsSql: string,
        StaticAttachmentDocumentIds: string[],
        StaticRecipients: EmailRecipient[]
    };
    Type?: number;
}

export interface EmailRecipient {
    EmailAddress: string;
    Kind: EmailRecipientKind;
    Id: string;
}

export enum EmailRecipientKind {
    Regular = 0,
    CarbonCopy = 1,
    BlindCarbonCopy = 2
}

export interface EmailTemplateContext extends Context {
    translations?: StringKeyDictionary<string>
}

export interface EmailTemplateProps extends AppBaseProps {
    entity: EmailTemplateEntity;
    context: EmailTemplateContext;
    disableEntityType: boolean;
}

const checkConsistency = (entity: EmailTemplateEntity, translations: StringKeyDictionary<string>): Promise<boolean> => {
    return new Promise<boolean>((resolve) => {
        const keys = Helper.mergeLists(Object.keys(entity.Name).filter(f => !Helper.isNullOrEmpty(entity.Name[f])), Object.keys(entity.Data));
        const names = keys.filter(key => Helper.isNullOrEmpty(entity.Name[key]));
        const data = keys.filter(key => !Helper.hasValue(entity.Data[key]));
        const languages: Language[] = Helper.loadDataFromStorage("email_languages");

        const labelLeft = names.length > 0 ? <label>{translations["WebSMS.ReportMetadata.NoTranslationCreated"]}</label> : null;
        const labelRight = data.length > 0 ? <label>{translations["WebCRM.Email.DatasourcesNotFilled"]}</label> : null;
        const v = (names.length > 0 ? 1 : 0) + (data.length > 0 ? 1 : 0)

        if (v == 0) {
            resolve(true);
        } else {
            const targetElement = $("<div>");
            const dialogProps: DialogProps = {
                title: "Gefundene Probleme",
                width: v == 1 ? 450 : 600,
                actions: [
                    {
                        label: translations["Standard.Abbrechen"],
                        action: () => {
                            resolve(false);
                        }
                    },
                    {
                        label: translations["Standard.OK"],
                        action: () => {
                            resolve(true);
                        },
                        primary: true
                    }
                ],
                afterClose: () => {
                    ReactDOM.unmountComponentAtNode(targetElement[0]);
                    targetElement[0].remove();
                }
            };
            $("body").append(targetElement);
            ReactDOM.render(
                <Dialog {...dialogProps} open={true}>
                    <table>
                        <tbody>
                            <tr>
                                <td colSpan={2}>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", margin: "8px" }}>
                                        <label>
                                            {translations["WebSMS.ReportMetadata.PartiallyIncorrect"]}
                                        </label>
                                        <label>
                                            {translations["WebSMS.ReportMetadata.StillSave"]}
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "10px" }}>{labelLeft}</td>
                                <td style={{ padding: "10px" }}>{labelRight}</td>
                            </tr>
                            <tr>
                                <td style={{ paddingLeft: "25px" }}>
                                    <ul>
                                        {names.map((key: string) => {
                                            let language = languages.find(f => f.Code == key);
                                            if (!Helper.hasValue(language)) {
                                                language = {
                                                    Code: key,
                                                    Displaynameen: key,
                                                    Displaynamenative: key,
                                                    Fallbackid: -1, 
                                                    Id: -1
                                                }
                                            }

                                            return (
                                                <React.Fragment key={kendo.guid()}>
                                                    <li style={{ listStyle: "disc" }}>
                                                        {`${language.Displaynameen}(${language.Displaynamenative})`}
                                                    </li>
                                                </React.Fragment>
                                            );
                                        })}
                                    </ul>
                                </td>
                                <td style={{ paddingLeft: "25px" }}>
                                    <ul>
                                        {data.map((key: string) => {
                                            let language = languages.find(f => f.Code == key);
                                            if (!Helper.hasValue(language)) {
                                                language = {
                                                    Code: key,
                                                    Displaynameen: key,
                                                    Displaynamenative: key,
                                                    Fallbackid: -1,
                                                    Id: -1
                                                }
                                            }
                                            return (
                                                <React.Fragment key={kendo.guid()}>
                                                    <li style={{ listStyle: "disc" }}>
                                                        {`${language.Displaynameen}(${language.Displaynamenative})`}
                                                    </li>
                                                </React.Fragment>
                                            );
                                        })}
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Dialog >, targetElement[0]
            );
        }


    });
}
